// Reducer: a function that takes in the old state, and an action => new state.
let transactions;
const contextReducer = (state, action) => {
    switch (action.type) {
        case 'DELETE_TRANSACTION' :
            transactions = state.filter((t)=> t.id !== action.payload); 
            //it'll keep all the transactions except for the one mentioned in action payload.

            //for local storage of data
            localStorage.setItem('transactions', JSON.stringify(transactions));
            return transactions;
            case 'ADD_TRANSACTION':
                transactions = [action.payload, ...state];
                //the transaction will be pushed in the front of the array
                localStorage.setItem('transactions', JSON.stringify(transactions));
                return transactions;

        default:
            return state; //state is the current transaction.
    }
}
export default contextReducer;